// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { Cart } from "@insite/client-framework/Services/CartService";

export const cartContainsNonOrDifferentPrebookItems = (cart: Cart, prebookSeason = "") => {
    if (!cart?.cartLines) return false;

    const allowedSeasons = prebookSeason.split("|").filter(s => s); // Remove empty strings

    return cart.cartLines.some(cartLine => {
        if ((cartLine as any).isPrebook === false) return true;

        const cartLineSeasons = ((cartLine as any).prebookSeason?.split("|") || []).filter((s: string) => s);
        if (allowedSeasons.length === 0 && cartLineSeasons.length === 0) return false;
        if (allowedSeasons.length === 0 || cartLineSeasons.length === 0) return true;
        return !cartLineSeasons.some((season: string) => allowedSeasons.includes(season));
    });
};